import React, { useEffect, useRef, useState } from "react";
import { UserCircle } from "../../../shared/assets/AppIcons";
import StaffFormFields from "./StaffFormFields";
import {
  CreateFormCancelButton,
  CreateFormDialog,
  CreateFormSubmitButton,
} from "../../../shared/components/CreateFormDialog";

export default function CreateStaffDialog({
  open,
  onOpenChange,
  form,
  onFieldChange,
  onSubmit,
  onCancel,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);

  useEffect(() => {
    if (!open) {
      submittingRef.current = false;
      setIsSubmitting(false);
    }
  }, [open]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);
    try {
      await onSubmit();
    } finally {
      submittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <CreateFormDialog
      busy={isSubmitting}
      open={open}
      onOpenChange={onOpenChange}
      icon={UserCircle}
      className="party-form-dialog"
      title="Nuovo membro esterno"
      footer={
        <>
          <CreateFormCancelButton onClick={onCancel} disabled={isSubmitting} />
          <CreateFormSubmitButton
            form="create-staff-form"
            saving={isSubmitting}
          >
            Crea membro esterno
          </CreateFormSubmitButton>
        </>
      }
    >
      <form
        id="create-staff-form"
        className="party-form create-form-dialog__form"
        onSubmit={handleSubmit}
      >
        <StaffFormFields value={form} onFieldChange={onFieldChange} splitName />
        <p className="party-form__help">Gli interni vengono aggiunti automaticamente quando li inviti da Utenti.</p>
      </form>
    </CreateFormDialog>
  );
}
